import * as R from 'ramda'

const isURLBlacklistedForRedirect = (pathname: string) =>
  R.any(
    (_) => pathname.startsWith(_),
    ['/auth', '/register', '/terms-and-conditions'],
  )

export default isURLBlacklistedForRedirect
